<div class="exception-body notfound">
    <div class="exception-panel">
        <h1>404</h1>
        <h3>not found</h3>
        <p>A página requisitada não existe!</p>
        <!--<button type="button" pButton label="Go back to home" [routerLink]="['/']"></button>-->
    </div>
    <div class="exception-footer">
        <img [src]="'assets/layout/images/uniftc-logo.png'" class="exception-logo"/>
        <span class="app-name">Experiência UniFTC</span>
    </div>
</div>
